import { connect } from 'react-redux';
import { getCurrentDashboard, getInsightsLoading } from 'core/selectors';
import { fetchDashboardDetail, fetchChartData } from 'core/slices/insights';
import InsightsDashboardViewComponent from '../../../components/insights/InsightsDashboardView';

export default connect(
  state => ({
    currentDashboard: getCurrentDashboard(state),
    loading: getInsightsLoading(state),
  }),
  {
    fetchDashboardDetail,
    fetchChartData,
  },
)(InsightsDashboardViewComponent);
